// Upload Avatar — Feature not yet implemented on the backend
// The useUploadAvatarMutation endpoint does not exist in the API.
// This component is disabled until the backend endpoint is added.

import React from 'react';
import MetaData from '../layout/MetaData';
import UserLayout from '../layout/UserLayout';

const UploadAvatar = () => {
  return (
    <UserLayout>
      <MetaData title="Upload Avatar" />
      <div className="row wrapper">
        <div className="col-10 col-lg-6">
          <div className="card p-4 text-center">
            <h2 className="mb-4">Upload Avatar</h2>
            <p className="text-muted">This feature is coming soon.</p>
          </div>
        </div>
      </div>
    </UserLayout>
  );
};

export default UploadAvatar;